import React from "react";
import type { IService } from "../../../store/@types/service";

type ServiceMultiSelectProps = {
  services: IService[];
  value: string[];
  onChange: (selectedServices: string[]) => void;
  error?: boolean;
};

const ServiceMultiSelect: React.FC<ServiceMultiSelectProps> = ({
  services,
  value,
  onChange,
  error = false,
}) => {
  const toggleService = (serviceId: string) => {
    onChange(
      value.includes(serviceId)
        ? value.filter((id) => id !== serviceId)
        : [...value, serviceId],
    );
  };

  return (
    <fieldset
      className={`mt-1 rounded-lg border p-3 ${
        error ? "border-red-500" : "border-gray-200"
      }`}
      aria-invalid={error}
    >
      <legend className="sr-only">Services</legend>
      {services.length ? (
        <div className="max-h-40 space-y-2 overflow-y-auto">
          {services.map((service) => {
            const serviceId = String(service.id);
            return (
              <label
                key={service.id}
                className="flex cursor-pointer items-center gap-2 text-sm text-gray-700"
              >
                <input
                  type="checkbox"
                  checked={value.includes(serviceId)}
                  onChange={() => toggleService(serviceId)}
                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                />
                {service.name}
              </label>
            );
          })}
        </div>
      ) : (
        <p className="text-sm text-gray-500">No services available.</p>
      )}
      {error && (
        <p className="mt-2 text-xs text-red-600">
          Select at least one service.
        </p>
      )}
    </fieldset>
  );
};

export default ServiceMultiSelect;
